import Vue, { Component } from 'vue';
import { Component as ComponentDecorator } from 'vue-property-decorator';
import CVueInstance from './CVueInstance';

@ComponentDecorator({
  props: {
    background: String,
    text: String,
    logoUrl: String,
    subText: String,
    buttonText: String,
    buttonPath: String,
  },
})

export default class CubeCTASection extends CVueInstance {
  get getId() {
    return `${this.GetMyId()}-ctasecion1`;
  }
  public mounted() {
    (window as any).$(this.getId).parallax('50%', 0.5);
  }
}
